import { IPersonalizationSettings } from "./Models";

export const PERSONALIZATION_DEFAULT_CACHE_EXPIRATION = 4 * 60 * 60 * 1000 // 4 hrs in ms

const defaultSettingsProd: IPersonalizationSettings = {
	environment: "prod",
	userFactsUrl: "https://attributes.engagement.office.com/facts",
	userFactsRequestTimeOut: 3000,
	userFactsCacheExpiration: PERSONALIZATION_DEFAULT_CACHE_EXPIRATION,
	eventSamplingRate: 1, //sample at 1%
};

const defaultSettingsInt: IPersonalizationSettings = {
	environment: "int",
	userFactsUrl: "https://attributes.engagement.office-int.com/facts",
	userFactsRequestTimeOut: 3000,
	userFactsCacheExpiration: PERSONALIZATION_DEFAULT_CACHE_EXPIRATION,
	eventSamplingRate: 1, //sample at 1%
};

const defaultSettingsEdog: IPersonalizationSettings = {
	environment: "edog",
	userFactsUrl: "https://attributes.engagement.officeppe.com/facts",
	userFactsRequestTimeOut: 3000,
	userFactsCacheExpiration: PERSONALIZATION_DEFAULT_CACHE_EXPIRATION,
	eventSamplingRate: 1, //sample at 1%
};

let customSettings: IPersonalizationSettings = defaultSettingsProd;

export function initSettings(inputSettings?: IPersonalizationSettings) {
	if (!initSettings) {
		return;
	}

	let defaultSettings = defaultSettingsProd;
	const environment = inputSettings?.environment ?? defaultSettingsProd.environment;
	switch (environment) {
		case "int":
			defaultSettings = defaultSettingsInt;
			break;
		case "edog":
			defaultSettings = defaultSettingsEdog;
			break;
		default:
			break;
	}

	customSettings = { ...defaultSettings, ...inputSettings };
}

export function getSetting<T>(name: keyof IPersonalizationSettings): T {
	return (customSettings[name] ?? defaultSettingsProd[name]) as unknown as T;
}

export function getSamplingRate(): number {
	const rate = getSetting("eventSamplingRate") as number;
	return !rate ? 0.01 : rate/100.0;
}
